export enum EmptyValues {
  DASH = '-',
  TIRET = '—',
}
